module.exports = __webpack_public_path__ + "img/qrcode.31888506.jpg";